// CANONICAL color source. Consumed by:
//  - BrandThemeProvider.tsx (antd ConfigProvider tokens)
//  - layout.tsx (injects :root CSS vars)
//  - globals.css @theme inline maps these var NAMES to Tailwind tokens.
// Adding a color? Add it here, then add the matching --color-* line in globals.css @theme.
export const brand = {
  primary: "#02698E",
  secondary: "#07435E",
  accent: "#E78021",
  bgLight: "#BEE4F4",
  surface: "#FFFFFF",
  textDark: "#0A1C2F",
  // Neutrals — match antd v6 defaults on white; don't change without a visual pass.
  inkSecondary: "#8c8c8c", // secondary/help text
  inkLabel: "#434343", // strong label text
  line: "#f0f0f0", // card/panel borders
  lineSoft: "#f5f5f5", // row dividers (.kv-* family)
  surfaceSubtle: "#fafafa", // subtle fills
  // Agent permissions colors (uses antd's red-6 and green-6)
  stateDenyFill: "#ffccc7",
  stateDenyInk: "#a8071a",
  stateAllowFill: "#d9f7be",
  stateAllowInk: "#237804",
  stateUnsetInk: "#8c8c8c"
} as const;

const toKebab = (k: string) => k.replace(/[A-Z]/g, (m) => `-${m.toLowerCase()}`);

export const brandCssVars = `:root{${Object.entries(brand)
  .map(([k, v]) => `--brand-${toKebab(k)}:${v};`)
  .join("")}}`;
